module.exports = "/_next/static/images/crypto-243b15e90fd5ed6f20a6ed4ec13e8c97.png";